// System health panel (approved HTML component: system-health).
import type { ReactNode } from 'react';

export interface SystemHealthProps {
  health: { routing: string; delayed: string; description: string };
}

export function SystemHealth({ health }: SystemHealthProps): ReactNode {
  return (
    <section className="n-card" data-component="system-health">
      <div className="n-head">
        <h2>System health</h2>
        <small />
      </div>
      <div className="n-body">
        <div className="n-row">
          <span className="n-pill green">{health.routing}</span>
          <span className="n-pill amber">{health.delayed}</span>
        </div>
        <p style={{ marginTop: 15 }}>{health.description}</p>
        <button type="button" className="n-link" data-source-link="shared-states">
          View source states →
        </button>
      </div>
    </section>
  );
}
